var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3C9.5 2.17157 8.82843 1.5 8 1.5C7.17157 1.5 6.5 2.17157 6.5 3H5.5C5.5 1.61929 6.61929 0.5 8 0.5C9.38071 0.5 10.5 1.61929 10.5 3H15C15.2761 3 15.5 3.22386 15.5 3.5C15.5 3.77614 15.2761 4 15 4H14.446L13.1499 15.2292C13.0335 16.2384 12.179 17 11.1631 17H4.83688C3.821 17 2.9665 16.2384 2.85006 15.2292L1.553 4H1C0.75454 4 0.550392 3.82312 0.508056 3.58988L0.5 3.5C0.5 3.22386 0.723858 3 1 3H9.5ZM13.438 4H2.561L3.84347 15.1146C3.90169 15.6192 4.32894 16 4.83688 16H11.1631C11.6711 16 12.0983 15.6192 12.1565 15.1146L13.438 4ZM6.5 6.5C6.74546 6.5 6.94961 6.65477 6.99194 6.85886L7 6.9375V13.0625C7 13.3041 6.77614 13.5 6.5 13.5C6.25454 13.5 6.05039 13.3452 6.00806 13.1411L6 13.0625V6.9375C6 6.69588 6.22386 6.5 6.5 6.5ZM9.5 6.5C9.74546 6.5 9.94961 6.65477 9.99194 6.85886L10 6.9375V13.0625C10 13.3041 9.77614 13.5 9.5 13.5C9.25454 13.5 9.05039 13.3452 9.00806 13.1411L9 13.0625V6.9375C9 6.69588 9.22386 6.5 9.5 6.5Z",
    fill: "#D13939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.6df622eab3bf80bb3a5890ef55b833d2.svg";
export { ForwardRef as ReactComponent };